import Slide from '@/models/Slide';

class QPVSlidesMapper {
  constructor(response) {
    this.response = response;
  }

  map() {
    const pm = this.mapPresentationMode();
    return {
      presentationMode: pm,
      items: this.mapItems()
    }
  }

  mapPresentationMode() {
    const defaultValue = 'PIP';

    const {presentation} = this.response;
    if (!presentation || !presentation.settings) {
      return defaultValue;
    }

    return presentation.settings.position || defaultValue;
  }

  mapItems() {
    const result = [];

    if (!this.response.presentation || !this.response.presentation.items) {
      return result;
    }

    const {items} = this.response.presentation;

    items.sort((a, b) => {
      if (a.start === b.start) {
        return 0;
      }

      return a.start < b.start ? -1 : 1;
    });

    for (let i = 0; i < items.length; ++i) {
      let end = (i < items.length - 1) ? items[i + 1].start : this.response.duration / 1000;
      result.push(new Slide({
        ...items[i],
        src: items[i].cdn_src || items[i].src,
        end: end
      }))
    }

    return result;
  }
}

export {
  QPVSlidesMapper
};
